/**
 * Icono de invernadero para la navegación.
 *
 * Lucide no trae ninguno (lo comprobamos: `House`, `Sprout`, `LeafyGreen`… pero
 * ninguno con forma de invernadero), así que es un SVG propio dibujado con las
 * mismas medidas que los iconos de la librería — 24x24, trazo de 2,
 * `currentColor` — para que se vea idéntico en grosor y color que el resto del
 * menú y siga tiñéndose de blanco en la barra lateral y del color de la fila en
 * el cajón «Más».
 */
interface GreenhouseIconProps {
  className?: string;
}

export function GreenhouseIcon({ className }: GreenhouseIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* Muros y cubierta a dos aguas */}
      <path d="M3 20v-8.5L12 5l9 6.5V20" />
      {/* El suelo */}
      <path d="M2 20h20" />
      {/* Palo central y travesaño: los cristales */}
      <path d="M12 5v15" />
      <path d="M3 13h18" />
    </svg>
  );
}
